/**
 * Role helpers. The backend knows two admin levels, both expressed through
 * `user_type`:
 *
 *  - `admin` — access to the admin area.
 *  - `super` — everything an admin may do, plus the super-admin-only areas
 *    (audit trail, impersonation, API tokens, WPCP admin, editing user_type).
 *
 * Purely role-based, mirroring `User#is_super_admin?` on the backend: user ID 1
 * has no implicit privileges, it is an ordinary account like any other.
 *
 * Always go through these helpers instead of comparing `user_type` inline, so a
 * super admin never loses access to a plain admin feature.
 */
export interface RoleBearer {
    user_type?: string | null;
}

export function isSuperAdmin(user: RoleBearer | null | undefined): boolean {
    if (!user) return false;
    return user.user_type === 'super';
}

export function isAdmin(user: RoleBearer | null | undefined): boolean {
    if (!user) return false;
    return user.user_type === 'admin' || user.user_type === 'super';
}
